// extracted by mini-css-extract-plugin
module.exports = {"default":"Brand_default__34jdH"};